'use client'

import React from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Grid, Link, Typography, Box, Paper, Container } from '@mui/material';
import ContactForm from '../ContactForm';

export const KontaktSection = ({ data }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <motion.section
      className="section-large"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: inView ? 1 : 0 }}
      transition={{ duration: 1 }}
    >
      <div className="section-header">
        <div className="section-title">
          <Typography variant="h3" component="h2" gutterBottom align="center">
            {data.Titel}
          </Typography>
        </div>
      </div>
      <div className="section-body">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ContactForm />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mx: 2, mb: 2 }}>
                <Box sx={{ my: 2 }}>
                  <Link href="https://maps.app.goo.gl/A1NVkCuQmukdQnkC9" target="_blank" rel="noopener noreferrer" underline="hover">
                    <Typography color="secondary">{data.Name}</Typography>
                    <Typography color="secondary">{data.Strasse}</Typography>
                    <Typography color="secondary">{data.Postleitzahl} {data.Ort}, {data.Land}</Typography>
                  </Link>
                  <Typography>
                    <Link href={`mailto:${data.EMail}`} underline="hover" color="secondary">{data.EMail}</Link>
                  </Typography>
                  <Typography>
                    <Link href={`tel:${data.Mobile}`} underline="hover" color="secondary">{data.Mobile}</Link>
                  </Typography>
                </Box>
                <Paper elevation={3} sx={{ overflow: 'hidden' }}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5456.371987344757!2d9.530208397270568!3d46.85971206482292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784c79c95c97e1d%3A0x757ad32e7e96b9d7!2sKaltbrunnstrasse%201%2C%207000%20Chur!5e0!3m2!1sde!2sch!4v1746469189598!5m2!1sde!2sch"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>
    </motion.section>
  );
};